'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HousingBadgeProps {
  name: string;
  backgroundColor?: string;
  textColor?: string;
  before?: React.ReactNode;
  after?: React.ReactNode;
  className?: string;
}

export function HousingBadge({
  name,
  backgroundColor,
  textColor,
  before,
  after,
  className,
}: HousingBadgeProps) {
  return (
    <div
      className={cn(
        'flex h-7 items-center justify-center gap-2 rounded-full px-4 sm:h-8 lg:h-9',
        className,
      )}
      style={{
        backgroundColor: backgroundColor ?? 'white',
      }}
    >
      {before}
      <p
        className="text-[11px] font-bold leading-[100%] sm:text-[12px] sm:leading-[100%] lg:text-sm lg:leading-[100%]"
        style={{ color: textColor ?? '#254124' }}
      >
        {name}
      </p>
      {after}
    </div>
  );
}
